import styled from 'styled-components'
import { NEUTRAL_100 } from '../../styles/colors'
import { INTER } from '../../styles/fonts'

// Cast to avoid ts(2883) portability error caused by @types/react version
// mismatch between packages/ui and other packages in the monorepo.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Container = (styled.div`
  font-family: ${INTER.light};
  font-size: 12px;
  border: 1px solid ${NEUTRAL_100};
  padding: 6px 8px;
  border-radius: 6px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
